import { SET_USER, REMOVE_USER } from "../reducers/Types";

import { refreshInfo } from "../baseparking-api/Auth";

export function setUser(payload) {
  return {
    type: SET_USER,
    payload
  };
}
export function removeUser() {
  return {
    type: REMOVE_USER
  }
}

export function refreshUser() {
  return (dispatch, getState) => {
    const token = localStorage.getItem("loginToken");
    if (token) {
      refreshInfo(token).then(res => {
        if (res.data) {
          dispatch(setUser(res.data.user));
          
        }
      });
    }
  };
}

export function logout() {
  return dispatch => {
    localStorage.removeItem('loginToken');
    dispatch(removeUser());
    window.location = "/login";
  }
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js